const $toogleIcon = $('.navbar__brand__menu-toggle');
const $mobileNav = $('nav');
const $searchIcon = $('.mobile-search-icon');
const $closeSearchIcon = $('.mobile-close-search');
const $searchForm = $('.search-form');

const renderNavbar = () => {
  const $desktopLinkBar = $('.navbar__login');
  const $mobileLinkBar = $('.navbar__menu__login');
  const windowWidth = window.innerWidth;
  const $languagePicker = $('.language-picker');

  if (windowWidth < 768) {
    const $desktopLinks = $desktopLinkBar.find('a').not('.dropdown-link');
    if ($desktopLinks.length) {
      $searchForm.addClass('search-form--hidden');
      $mobileNav.append('<ul class="nav navbar-nav navbar__menu__login"></ul>');
      $languagePicker
        .appendTo('.navbar__menu__login')
        .wrap('<li class="nav-item login-item"></li>')
        .addClass('nav-link');
      $desktopLinks
        .appendTo('.navbar__menu__login')
        .wrap('<li class="nav-item login-item"></li>')
        .addClass('nav-link');
      $desktopLinkBar.find('li').remove();
    }
  } else {
    const $mobileLinks = $mobileLinkBar.find('a').not('.dropdown-link');
    if ($mobileLinks.length) {
      $searchForm.removeClass('search-form--hidden');
      $languagePicker
        .appendTo('.navbar__login ul')
        .wrap('<li></li>')
        .removeClass('nav-link');
      $mobileLinks
        .appendTo('.navbar__login ul')
        .wrap('<li></li>')
        .removeClass('nav-link');
      $mobileLinkBar.remove();
    }
  }
};

// -----

renderNavbar();
$toogleIcon.on('click', e => {
  $mobileNav.toggleClass('open');
  e.stopPropagation();
});
$(document).on('click', (event) => {
  if (event.target.className && event.target.className.includes && !event.target.className.includes('menu-item-parent')) {
    $mobileNav.removeClass('open');
  }
});
$(window).on('resize', renderNavbar);
$searchIcon.on('click', () => {
  $searchForm.removeClass('search-form--hidden');
  $searchForm.find('input.form-control').focus();
});
$closeSearchIcon.on('click', () => {
  $searchForm.addClass('search-form--hidden');
  $searchForm.find('input.form-control').blur();
});

// Mega Menu
$(document).on('touchstart', (event) => {
  if (
    event.target.className !== 'nav-item' &&
    event.target.className !== 'item' &&
    event.target.className !== "dropdown" &&
    $(event.target).parents("div.dropdown").length === 0
  ) {
    $("div.dropdown").css('display', 'none');
    $("div.nav-item").css('background-color', '#f0eae4');
  }
})

$(".nav-item").on('touchstart', (event) => {
  $("div.dropdown").css('display', 'none');
  $("div.nav-item").css('background-color', '#f0eae4');
  const dropdown = $($(event.currentTarget).find(".dropdown")[0]);
  if ((event.target.className === 'nav-item' || event.target.className === 'item') && dropdown.length > 0) {
    event.preventDefault();
    dropdown.css('display', 'flex');
    $(dropdown[0].parentNode).css('background-color', '#fff');
  } else if (event.target.className === "dropdown" || $(event.target).parents("div.dropdown").length > 0) {
    dropdown.css('display', 'flex');
    $(dropdown[0].parentNode).css('background-color', '#fff');
  }
});
// -----
